module.exports = __webpack_public_path__ + "img/Cuidando_tu_vision.136567c6.svg";